// WAF EventFilterBar-style filter row for API Security event/audit pages.
import React from "react";
import {
  Stack, Box, Typography, InputAdornment, Select, MenuItem} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Filter } from "lucide-react";

import colors from "../../../../../../utils/colors";
import LayerdIcon from "../../../../../common/LayerdIcon";
import { EVENT_FILTER_BAR_SX, filterSelectSx } from "../asecUi";
import { eventSearchInputSx } from "../../../detection/eventSearchInputSx";
import { SafeTextField } from "../../../../../common/Greens";

function chipCount(chip) {
  const n = chip.ct ?? chip.count;
  return typeof n === "number" ? n.toLocaleString() : n;
}

export function AsecEventsFilterBar({
  search,
  onSearchChange,
  searchPlaceholder = "Search…",
  categoryFilter,
  onCategoryChange,
  chips,
  children,
  action,
  trailing,
  sx,
}) {
  return (
    <Box sx={{ ...EVENT_FILTER_BAR_SX, ...sx }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ gap: 1.5 }}>
        <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" sx={{ gap: 1.5, flex: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <LayerdIcon icon={Filter} size={18} color="primary" />
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: colors.neutral[800] }}>
              Filters
            </Typography>
          </Stack>

          {typeof search === "string" && onSearchChange ? (
            <SafeTextField
              placeholder={searchPlaceholder}
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              sx={{ ...eventSearchInputSx, maxWidth: 320, flex: "1 1 200px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      className="event-search-icon"
                      sx={{
                        fontSize: 16,
                        color: colors.primary[300],
                        transition: "color 140ms ease",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          ) : null}

          {children}

          {chips?.length > 0 && onCategoryChange ? (
            <Select
              value={categoryFilter}
              onChange={(e) => onCategoryChange(e.target.value)}
              sx={{ ...filterSelectSx, minWidth: 160 }}
            >
              {chips.map((c) => (
                <MenuItem key={c.key} value={c.key}>
                  {c.label} ({chipCount(c)})
                </MenuItem>
              ))}
            </Select>
          ) : null}
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2} sx={{ flexShrink: 0 }}>
          {action ? <Box>{action}</Box> : null}
          {trailing}
        </Stack>
      </Stack>
    </Box>
  );
}
